module.exports = __webpack_public_path__ + "static/media/fonts-9.3c1693db.svg";